import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem, NavDropdown, MenuItem } from '../utils/bootstrap';

const links = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'About Us',
    children: [
      {
        title: 'About Us',
        link: '/about-us',
      },
      {
        title: 'Our Team',
        link: '/our-team',
      },
    ]
  },
  {
    title: 'Products',
    children: [
      {
        title: 'Premium Financing',
        link: '/products/premium-financing',
      },
      {
        title: 'Business Financing',
        link: '/products/business-financing',
      },
    ]
  },
  {
    title: 'Contact Us',
    link: '/contact-us',
  },
  {
    title: 'Downloads',
    link: '/downloads',
  },
];

class Navigation extends React.Component {
  closeNav = () => {
    this.menuItems.style.width = '0%';
    this.menuList.style.width = '0%';
  };

  openNav = () => {
    this.menuItems.style.width = '100%';
    this.menuList.style.width = '100%';
  };

  horizontalNav = () => {
    const { location: {pathname}, history } = this.props;
    return (
      <ul className="nav-list">
        {
          links.map(({ title, link, children }) => {
            if (children) {
              return (
                <NavDropdown title={title} id={title} key={title}>
                  {children.map(({ title, link }) => (
                    <MenuItem onClick={() => history.push(link)} active={pathname === link} key={link}>
                      {title}
                    </MenuItem>
                  ))}
                </NavDropdown>
              )
            }

            return (
              <NavItem onClick={() => history.push(link)} className={pathname === link ? 'active' : ''} key={link}>
                {title}
              </NavItem>
            )
          })
        }
      </ul>
    )
  };

  sideNav = () => (
    <div ref={node => this.menuList = node} className="side-nav__overlay">
      <div ref={node => this.menuItems = node} className="side-nav">
        <ul>
          <a className="closebtn" onClick={this.closeNav}>&times;</a>
          {
            links.map(({ title, link, children }) => {
              if (children) {
                return (
                  <li key={title}>
                    <a className="disabled">{title}<span className="caret"/></a>
                    <ul style={{ margin: '0 0 2rem 1.5rem' }}>
                      {children.map(this.sideNavLink)}
                    </ul>
                  </li>
                )
              }

              return this.sideNavLink({ title, link });
            })
          }
        </ul>
      </div>
    </div>
  );

  sideNavLink = ({ title, link }) => (
    <li key={link}>
      <NavLink to={link} exact onClick={this.closeNav}>{title}</NavLink>
    </li>
  );

  render() {
    return (
      <nav>
        <div className="nav-brand">
          <NavLink exact to="/">
            <img src="/PCP.png" alt="Premium Capital" className="nav-logo" />
          </NavLink>
        </div>
        {this.horizontalNav()}
        <div className="nav-menu" onClick={this.openNav}>&#9776;</div>
        {this.sideNav()}
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navbar.js